export const likedUsersQueryKey = ['likedUsers'] as const;

export interface LikedUserRecord {
    _id: string;
    user: string;
    likedUser: string;
    createdAt: string;
    updatedAt: string;
}

export interface LikedUsersResponse {
    count: number;
    likedUsers: LikedUserRecord[];
}

const emptyLikedIds = new Set<string>();

export function likedIdSet(data: LikedUsersResponse | undefined): Set<string> {
    if (!data?.likedUsers?.length) return emptyLikedIds;
    return new Set(data.likedUsers.map((like) => String(like.likedUser)));
}

export function withLikedUser(
    current: LikedUsersResponse | undefined,
    likedUserId: string,
    liked: boolean,
): LikedUsersResponse | undefined {
    const id = String(likedUserId);
    const existing = current?.likedUsers ?? [];
    const alreadyLiked = existing.some((like) => String(like.likedUser) === id);
    if (liked === alreadyLiked) return current;

    const now = new Date().toISOString();
    const likedUsers = liked
        ? [...existing, { _id: '', user: '', likedUser: id, createdAt: now, updatedAt: now }]
        : existing.filter((like) => String(like.likedUser) !== id);

    return { count: likedUsers.length, likedUsers };
}
